<div class="create-invitation">
  <img src="./assets/images/bask/add-joint-owner.svg" alt="Add a joint account owner">
  <h1>Add a Joint Owner</h1>
  <h3>Here are a few things to know about adding a joint owner:</h3>
  <ul>
    <li>Joint owner must be at least 18 years of age.</li>
    <li>The invitee, after accepting the invitation received via email, must meet identity and eligibility requirements in order to be added to the account(s).</li>
    <li>Each joint owner has complete control over all funds in the account(s).</li>
    <li>Each joint owner is liable for the account(s).</li>
  </ul>
  <p>Once the invitation is sent, it is valid for 7 days. If the invitation is not accepted or expires, you can resend the invitation. For more information on joint accounts, please visit our FAQs.</p>
  <mat-divider></mat-divider>
  <app-personal-details></app-personal-details>
</div>
